function setSimpleVideoAspectRatio(videoBlock, width, height) {
  const w = Number(width);
  const h = Number(height);
  if (!videoBlock || !w || !h) return;
  videoBlock.style.setProperty('--simple-video-aspect-ratio', w + ' / ' + h);
}

function isSimpleVideoMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function getActiveSimpleYoutubeIframe(videoBlock) {
  const desktopIframe = videoBlock.querySelector('.simple-video__youtube--desktop');
  const mobileIframe = videoBlock.querySelector('.simple-video__youtube--mobile');
  if (isSimpleVideoMobile()) return mobileIframe || desktopIframe;
  return desktopIframe || mobileIframe;
}

function getSimpleYoutubeAspectData(videoBlock) {
  const isMobile = isSimpleVideoMobile();
  let youtubeId = '';
  let isShort = false;

  if (isMobile && videoBlock.dataset.youtubeIdMobile) {
    youtubeId = videoBlock.dataset.youtubeIdMobile;
    isShort = videoBlock.dataset.youtubeIsShortMobile === 'true';
  } else if (videoBlock.dataset.youtubeIdDesktop) {
    youtubeId = videoBlock.dataset.youtubeIdDesktop;
    isShort = videoBlock.dataset.youtubeIsShortDesktop === 'true';
  } else if (videoBlock.dataset.youtubeIdMobile) {
    youtubeId = videoBlock.dataset.youtubeIdMobile;
    isShort = videoBlock.dataset.youtubeIsShortMobile === 'true';
  }

  return { youtubeId, isShort };
}

async function applySimpleYoutubeAspectRatio(videoBlock) {
  const { youtubeId, isShort } = getSimpleYoutubeAspectData(videoBlock);
  if (!youtubeId) return;

  if (isShort) {
    setSimpleVideoAspectRatio(videoBlock, 9, 16);
    return;
  }

  try {
    const watchUrl = 'https://www.youtube.com/watch?v=' + youtubeId;
    const response = await fetch(
      'https://www.youtube.com/oembed?url=' + encodeURIComponent(watchUrl) + '&format=json'
    );
    if (!response.ok) throw new Error('YouTube oEmbed request failed');
    const data = await response.json();
    if (data.width && data.height) {
      setSimpleVideoAspectRatio(videoBlock, data.width, data.height);
      return;
    }
  } catch (error) {
    console.warn('Simple video: could not load YouTube aspect ratio', error);
  }

  setSimpleVideoAspectRatio(videoBlock, 16, 9);
}

function applySimpleUploadedVideoAspectRatio(videoBlock, video) {
  function applyFromMetadata() {
    if (video.videoWidth && video.videoHeight) {
      setSimpleVideoAspectRatio(videoBlock, video.videoWidth, video.videoHeight);
    }
  }
  if (video.readyState >= 1) {
    applyFromMetadata();
  } else {
    video.addEventListener('loadedmetadata', applyFromMetadata, { once: true });
  }
}

function applySimplePosterImageAspectRatio(videoBlock, poster) {
  const img = poster.querySelector('img.simple-video__thumbnail');
  if (!img) return;
  function applyFromImage() {
    if (img.naturalWidth && img.naturalHeight) {
      setSimpleVideoAspectRatio(videoBlock, img.naturalWidth, img.naturalHeight);
    }
  }
  if (img.complete) {
    applyFromImage();
  } else {
    img.addEventListener('load', applyFromImage, { once: true });
  }
}

function hideAllSimpleYoutubeIframes(videoBlock) {
  videoBlock.querySelectorAll('.simple-video__youtube').forEach(function (iframe) {
    iframe.style.display = 'none';
  });
}

function initSimpleVideos(root) {
  const scope = root || document;
  scope.querySelectorAll('.simple-video__inner').forEach(function (videoBlock) {
    if (videoBlock.dataset.simpleVideoReady === 'true') return;
    videoBlock.dataset.simpleVideoReady = 'true';

    const poster = videoBlock.querySelector('.simple-video__poster');
    const video = videoBlock.querySelector('video.simple-video__media');
    const youtubeIframes = videoBlock.querySelectorAll('.simple-video__youtube');
    const hasYoutube = youtubeIframes.length > 0;

    if (hasYoutube) {
      applySimpleYoutubeAspectRatio(videoBlock);
      window.addEventListener('resize', function () {
        applySimpleYoutubeAspectRatio(videoBlock);
      });
    } else if (video) {
      applySimpleUploadedVideoAspectRatio(videoBlock, video);
    } else if (poster) {
      applySimplePosterImageAspectRatio(videoBlock, poster);
    }

    if (!poster || (!video && !hasYoutube)) return;

    function hidePoster() {
      poster.style.display = 'none';
    }

    function showPoster() {
      poster.style.display = '';
    }

    function playYoutube() {
      const activeIframe = getActiveSimpleYoutubeIframe(videoBlock);
      if (!activeIframe) return;
      hideAllSimpleYoutubeIframes(videoBlock);
      hidePoster();
      activeIframe.style.display = 'block';

      const baseSrc = activeIframe.dataset.src;
      if (!baseSrc) return;
      if (!activeIframe.src) {
        const joiner = baseSrc.indexOf('?') > -1 ? '&' : '?';
        activeIframe.src = baseSrc + joiner + 'autoplay=1';
      }
    }

    function playUploadedVideo() {
      hidePoster();
      video.style.display = 'block';
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          showPoster();
          video.style.display = '';
        });
      }
    }

    poster.addEventListener('click', function () {
      if (hasYoutube) {
        playYoutube();
        return;
      }
      if (video) playUploadedVideo();
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initSimpleVideos(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initSimpleVideos(event.target);
});
